// Upload file ke GoFile.io supaya dapat link publik yang PERMANEN.
//
// Kenapa ini dibutuhkan: tombol "Share" versi lama membuat link yang berisi
// URL CDN Discord asli (message.attachments[0].url). URL itu ditandatangani
// dan KEDALUWARSA setelah beberapa jam - jadi link share lama gampang rusak.
// GoFile menyimpan salinan file itu sendiri, jadi link-nya tidak tergantung
// umur URL CDN Discord.
//
// Dokumentasi resmi: https://gofile.io/api
// (upload publik, tanpa perlu token/akun - lihat bagian "Uploading")

const GOFILE_UPLOAD_URL = "https://upload.gofile.io/uploadfile";

// Upload sebagai akun "guest" (tanpa token). Ini resmi didukung GoFile dan
// cukup untuk kebutuhan share sederhana: file otomatis dapat halaman
// download publik (downloadPage) yang bisa dibagikan ke siapa saja.
export async function uploadToGofile(blob, filename, onProgress = null) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open("POST", GOFILE_UPLOAD_URL, true);

        if (onProgress) {
            xhr.upload.onprogress = (event) => {
                if (event.lengthComputable) {
                    onProgress(event.loaded, event.total);
                }
            };
        }

        xhr.onload = () => {
            let response;
            try {
                response = JSON.parse(xhr.responseText);
            } catch (e) {
                reject(new Error(`Respons GoFile tidak valid (status HTTP ${xhr.status}).`));
                return;
            }
            // GoFile selalu membungkus hasil dalam field "status" - cek ini,
            // bukan cuma HTTP code, karena beberapa error tetap balas HTTP 200.
            if (response.status !== "ok") {
                reject(new Error(`Upload ke GoFile gagal: ${response.status}`));
                return;
            }
            resolve(response.data);
        };
        xhr.onerror = () => reject(new Error("Gagal terhubung ke GoFile.io. Cek koneksi internet kamu."));

        const formData = new FormData();
        formData.append("file", blob, filename);
        xhr.send(formData);
    });
}
